exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cof-field[data-v-f320b492] {\n  margin-right: 5px;\n}\n.errors[data-v-f320b492] {\n  color: #ff0000 !important;\n}\n.key-wrap[data-v-f320b492] {\n  max-width: 100px;\n  word-wrap: break-word;\n}\n.fee-checkbox[data-v-f320b492] {\n  -webkit-appearance: checkbox;\n}\n.content-table strong.c1[data-v-f320b492] {\n  color: #13ce67;\n}\n.content-table strong.c2[data-v-f320b492] {\n  color: #ffa700;\n}\n.content-table strong.c3[data-v-f320b492] {\n  color: #41566c;\n}\n.content-table strong.c4[data-v-f320b492] {\n  color: #e23434;\n}\n.content-tlist[data-v-f320b492] {\n  border: none;\n}", ""]);

// exports
